module.exports = __webpack_public_path__ + "static/media/Profile_Pic.9d9d2696.png";